import { renderComposition } from "./composition-view.js";

export function mountFeed(rootEl) {
  let nextCursor = null;
  let loading = false;
  let exhausted = false;
  let mountObserver = null;
  let pageObserver = null;

  async function fetchPage() {
    if (loading || exhausted) return;
    loading = true;
    const url = new URL("/api/createdtime", location.origin);
    url.searchParams.set("limit", "10");
    if (nextCursor) url.searchParams.set("cursor", String(nextCursor));
    const res = await fetch(url);
    const body = await res.json();
    loading = false;
    nextCursor = body.nextCursor;
    exhausted = !nextCursor;
    if (body.items.length === 0 && !rootEl.children.length) {
      rootEl.innerHTML = '<div class="empty">No times have been created yet.</div>';
      return;
    }
    for (const comp of body.items) appendShell(comp);
    attachPageObserver();
  }

  function appendShell(comp) {
    const article = document.createElement("article");
    article.className = "cd-item";
    article.dataset.id = comp.id;
    article.innerHTML = `<div class="cd-placeholder">${escapeHtml(comp.title)} — ${comp.author ? escapeHtml(comp.author) : "anonymous"}</div>`;
    rootEl.appendChild(article);
    mountObserver.observe(article);
    article._comp = comp;
  }

  function attachPageObserver() {
    if (pageObserver) pageObserver.disconnect();
    const items = rootEl.querySelectorAll(".cd-item");
    if (items.length < 2) return;
    const trigger = items[items.length - 2];
    pageObserver = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) { pageObserver.disconnect(); fetchPage(); }
    }, { rootMargin: "300px" });
    pageObserver.observe(trigger);
  }

  mountObserver = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        const el = entry.target;
        mountObserver.unobserve(el);
        renderComposition(el, el._comp);
      }
    }
  }, { rootMargin: "200px" });

  fetchPage();
}

function escapeHtml(s) {
  return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
